import axios from 'axios'

export async function signup({ name, email, password }) {
  try {
    const response = await axios.post(
      'https://HealthStore.bravesoldier.repl.co/auth/signup',
      {
        name: name,
        email: email,
        password: password,
      }
    )
    return response.data
  } catch (err) {
    return {
      success: false,
      error: {
        message: err,
      },
    }
  }
}

export async function login({ email, password }) {
  try {
    const response = await axios.post(
      'https://HealthStore.bravesoldier.repl.co/auth/login',
      {
        email: email,
        password: password,
      }
    )
    return response.data
  } catch (err) {
    return {
      success: false,
      error: {
        message: err,
      },
    }
  }
}
